module.exports = __webpack_public_path__ + "assets/icons/video-check-0574.svg";